// mediaTagging/tagRedrawPatch.js — what a re-drawn EXISTING box may change in the store.
//
// An existing box gets new coordinates (drag, resize, re-mount) but keeps its text, level and metadata. The draw
// data has no metadata of its own: from a fresh draw it is null (TagBoxJQueryAdapter #resolveCoordsFromPercentData),
// read from the element it is missing. Copying that null over the stored metadata erased the PDF page / video start
// time — on production boxes ended up without a page (bug:tagging-duplicate-core-boxes-without-meta).
// Pure decision, kept out of TaggingCore so it is testable without jQuery.

// Does this draw event look like the SECOND handling of one draw? A fresh draw of a new box sends metadata: null, but
// it only meets an existing box when the same event is processed twice (a second core or listener). Drag/resize
// data carry no metadata key at all, a re-mount from the API carries the stored value — neither matches.
export function isDuplicateDrawEvent(existing, data = {}) {
    return data.metadata === null && existing.metadata != null;
}

export function buildRedrawPatch(existing, data = {}) {
    const { metadata, ...rest } = data;
    const patch = { ...rest, level: existing.level, text: existing.text };
    if (metadata != null) { patch.metadata = metadata; }   // only a real value may replace the stored one
    return patch;
}
